import sysadminOnly from '@/modules/user/components/nodeAllocationGuard'

const TheAdminMain = () => import('../views/TheAdminMain')
const TheAdminOverview = () => import('../views/TheAdminOverview')
const TheAdminNodeAllocation = () => import('../views/TheAdminNodeAllocation')

export default [
    {
        path: '/',
        name: 'admin-main',
        components: {
            default: TheAdminMain
        },
        children: [
            {
                path: '/admin',
                name: 'admin-overview',
                components: {
                    default: TheAdminOverview
                }
            },
            {
                path: '/admin/node-allocation',
                name: 'admin-node-allocation',
                components: {
                    default: TheAdminNodeAllocation
                },
                beforeEnter: sysadminOnly
            }
        ]
    }
]
